import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './logo.png';

export const Header = () => {
    const navigate = useNavigate();
    return <div className='p-5 flex justify-between'>
        <div className="flex cursor-pointer" onClick={() => navigate('/')}>
            <img src={logo} alt="" className='h-10 mr-5'/>
            <h2 className='text-xl'>Дорогою добра</h2>
        </div>
        <div className="flex cursor-pointer" onClick={() => navigate('/me')}>
            <p>Аккаунт</p>
        </div>
    </div>
}